export default __webpack_public_path__ + "static/media/7.92eb52df.svg";